import React, {useState, useEffect} from 'react';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { 
    BarChart, 
    Bar,
    CartesianGrid, 
    Tooltip,  
    ResponsiveContainer
} from 'recharts';
import './Overview.scss';
//service
import api from "../../../services/api";
import moment from "moment";
import "moment/locale/pt-br";
moment.locale("pt-br");


function CardInfo( props ) {

    const { title, value, percent, status,  footerValue, footerSubtitle } = props;

    return (
        <div className={`card-container ${ status ? 'positive': 'negative'}`}>
            <span className='card-title'> {title}</span>
            <div className='card-content'>
                <span className='card-value'> {value}</span>
                {/* <span className='card-percent'>
                    
                    { status ? 
                        <ArrowUpwardIcon className={"card-icon"} />  :
                        <ArrowDownwardIcon className={"card-icon"} />
                    }
                    {percent}%
                </span> */}
            </div>
            <div className='card-footer'>
                {/* <span className='footer-value'>{footerValue}</span> */}
                <span className='footer-subtitle'>{footerSubtitle}</span>
            </div>
        </div>
    );
}

function CardInfoList( props ) {
    
    const { title, tags } = props;

    return (
        <div className='cardList-container'>
            <span className='cardList-title'> {title} </span>
            <div className='cardList-tags'>
                {   
                    tags.map(tag => {
                        return (
                            <div className='tag-content'>
                                {`${tag[0]} ${tag[1]}`}
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

function CustomTooltip({ payload, label, active }) {
  if (
      active &&
      payload &&
      payload.length > 0 &&
      payload[0]?.payload?.init_week &&
      payload[0]?.payload?.number_access
  ) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`Semana : ${moment(payload[0].payload.init_week.value).format("DD/MM/YY")}`}</p>
        <p className="label">{`Número de acessos: ${payload[0].payload.number_access}`}</p>   
      </div>
    );
  }

  return null;
}

function Overview ({tags, totalAttenders, connections, eventId}){
    const [dateInit, setDateInit] = useState();
    const [dateFinal, setdateFinal] = useState();
    const [dataChart, setdataChart] = useState();
    const [showLoading, setShowLoading] = useState(false);

    
    const getChartInfo = async () => {
      if( eventId ){    
        setdataChart([]);
        setShowLoading(true);
        await api
          .get(`/getCountAccessCommunity/`, { params: { 
            id: eventId, 
            data_init: dateInit,
            data_final: dateFinal
          } })
          .then((res) => {
            setShowLoading(false);
            setdataChart(res.data);
          })
          .catch((err) => {
            setShowLoading(false);
            console.log(err)
          });
      }
    }

    useEffect(() => {
        if( dateInit && dateFinal && eventId) getChartInfo();
        return () => {}
    }, [ dateInit, dateFinal ]);

    return (
        <div className='overview-container'>
            <div className='list-cards-container'>
                <CardInfo
                    title='Total membros'
                    value={totalAttenders}
                    percent='5'
                    status={true}
                    footerValue='+ 16 membros'
                    footerSubtitle='nos últimos 30 dias'
                />
                
                <CardInfo
                    title='Total conexões'
                    value={connections}
                    percent='100'
                    status={false}
                    footerValue='0 conexões'
                    footerSubtitle='nos últimos 30 dias'
                />
                
                {  tags &&        
                    <CardInfoList
                        title='Total conexões'
                        tags={tags}
                    />
                }
            </div>
            
             <div className='overview-chart'>
                <div className='chart-title'>
                    <span>Total de acessos</span>
                </div>
                <div className='chart-filters'>
                    <div className="form__group field">
                        <label 
                            for="data-init" 
                            className="form__label"
                        >
                            De
                        </label>
                        <input
                            type={'month'}
                            min="2000-01" 
                            onChange={ e => { if(e.target.checkValidity()) setDateInit(e.target.value) }} 
                            className="form__field"
                            placeholder="__/__/__"         
                            name="data-init"
                            id="data-init"
                            autocomplete="off"
                            required
                        />
                    </div>

                    <div className="form__group field final">
                        <label 
                            for="data-final" 
                            className="form__label"
                        >
                            Até
                        </label>
                        <input
                            type={'month'}
                            min="2000-01" 
                            onChange={ e => { if(e.target.checkValidity()) setdateFinal(e.target.value) }} 
                            className="form__field"
                            placeholder="__/__/__"         
                            name="data-final"
                            id="data-final"
                            autocomplete="off"
                            required
                        />
                    </div>
                </div>
                <div className='chart-content'>
                { showLoading && 
                    <div className='container-chart-loader'>
                      <div class="lds-chart"><div></div><div></div><div></div></div>
                    </div>
                }
                      <div className='rotate-text'>
                          <span className='side-name'> Número de acessos </span>
                      </div>
            
                      <ResponsiveContainer>
                          <BarChart
                              data={dataChart}
                              margin={{
                                  top: 5,
                                  right: 30,
                                  left: 20,
                                  bottom: 5,
                              }}
                          >
                              <CartesianGrid strokeDasharray="3" />
                              <Tooltip wrapperStyle={{ backgroundColor: '#FFF', border: "1px solid #E5E5E5", padding: 10 }} content={<CustomTooltip />}/>   
                              <Bar dataKey="number_access" barSize={40} fill="#51A6FF"/>                
                          </BarChart>
                      </ResponsiveContainer>
                      <div className='final-text'>
                          <span className='side-name'> Semanas </span>
                      </div>
                  </div>
            </div>
        </div>
    )
}

export default Overview;